import { render, staticRenderFns } from "./HubPromotionsBanner.vue?vue&type=template&id=59cc3505&scoped=true"
import script from "./HubPromotionsBanner.vue?vue&type=script&lang=js"
export * from "./HubPromotionsBanner.vue?vue&type=script&lang=js"
import style0 from "./HubPromotionsBanner.vue?vue&type=style&index=0&id=59cc3505&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cc3505",
  null
  
)

export default component.exports